import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryTryDemo',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isBiggerSm } = useBreakpoint('sm');
const { isBiggerThanBreakpoint: isBiggerMd } = useBreakpoint('md');

const backgroundImage = computed(() =>
  getAssetUrl(
    isBiggerMd.value
      ? props.data.backgroundImageDesktop
      : props.data.backgroundImageMobile,
  ),
);

return { __sfc: true,props, getAssetUrl, isBiggerSm, isBiggerMd, backgroundImage }
}

})